import * as actions from './actions';
import reducers from './reducer';

export const Beatz = { actions, reducers };
export { BeatzState } from './reducer';
